import { ApolloQueryResult, FetchResult, gql } from '@apollo/client';
import { inject, injectable } from 'tsyringe';
import {
  MutationCleaningReportSubscriptionUpdateBatchArgs,
  ResponseCleaningReportSubscriptions,
} from '../../cross-cutting-concerns/communication/interfaces/am-api-graphql';
import { AmGraphQlClient } from 'app/cross-cutting-concerns/communication/clients/AmGraphQlClient';

export type CleaningClientReportSubscriptionOptions = MutationCleaningReportSubscriptionUpdateBatchArgs;

@injectable()
export class CleaningReportSubscriptionClient {
  constructor(@inject('AmGraphQlClient') private client: AmGraphQlClient) {}

  public get = async (): Promise<ApolloQueryResult<ResponseCleaningReportSubscriptions>> =>
    this.client.query({
      query: gql`
        query CleaningReportSubscriptions {
          cleaningReportSubscriptions {
            data {
              type
              interval
              formats
            }
          }
        }
      `,
    });

  public save = async ({
    lang,
    cleaningReportSubscriptions,
    timezone,
  }: CleaningClientReportSubscriptionOptions): Promise<FetchResult<ResponseCleaningReportSubscriptions>> =>
    this.client.mutate({
      mutation: gql`
        mutation CleaningReportSubscriptionUpdateBatch(
          $cleaningReportSubscriptions: [InputCleaningReportSubscription!]!
          $lang: SupportedLanguage!
          $timezone: String
        ) {
          cleaningReportSubscriptionUpdateBatch(
            lang: $lang
            cleaningReportSubscriptions: $cleaningReportSubscriptions
            timezone: $timezone
          ) {
            data {
              type
              interval
              formats
              timezone
            }
          }
        }
      `,
      variables: {
        lang,
        cleaningReportSubscriptions,
        timezone,
      },
    });
}
